'use client';

import { Button } from '@/components/ui/button';
import { sendErrorToBackend } from '@/core/lib/api/main/errorReporter';
import { useEffect } from 'react';
import { AlertTriangle } from 'lucide-react';
import { useDictionary } from '@/core/hooks/use-dictionary';
import { Heading } from '@/components/ui/Heading';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';

export default function Error({
    error,
    reset,
}: {
    error: Error & { digest?: string };
    reset: () => void;
}) {
    const { dictionary } = useDictionary();

    useEffect(() => {
        console.error('Caught error:', error);
        sendErrorToBackend({
            message: error.message,
            file: 'Root error handler', // Or extract from stack if possible
            line: 1, // Placeholder; parse from stack if needed
            stack_trace: error.stack || 'No stack trace',
            url: window.location.href,
        });
    }, [error]);

    return (
        <div className='w-full h-screen flex items-center justify-center'>
            <div className='rounded-lg bg-white p-8 shadow-lg flex flex-col'>
                <div className="flex items-center justify-center">
                    <AlertTriangle className="text-red-600" size={40} />
                </div>
                <Heading level={2} className="mt-4 text-center">
                    {dictionary.errors.errorOccurred}
                </Heading>
                <p className="mt-4 text-center text-primary-600 text-sm">
                    {dictionary.errors.errorOccurredMessage}
                </p>
                <Button
                    onClick={reset} className='mt-6 mx-auto'
                >
                    {dictionary.errors.retry}
                </Button>

                {process.env.NEXT_PUBLIC_APP_ENV === 'development' && (
                    <Collapsible className="mt-8">
                        <CollapsibleTrigger asChild>
                            <Button
                                variant="outline"
                                className='text-primary-600'
                            >
                                {dictionary.errors.moreDetails}
                            </Button>
                        </CollapsibleTrigger>

                        <CollapsibleContent className="mt-6">
                            <p className='justify-end flex flex-wrap text-sm text-red-600'>
                                {error.message}
                            </p>

                        </CollapsibleContent>
                    </Collapsible>
                )}
            </div>
        </div>
    );
}